import React from 'react';
import { CategoryColorPickerView, CategoryColorPickerViewProps } from './CategoryColorPicker.view';

export type CategoryColorPickerControllerProps = Omit<CategoryColorPickerViewProps, 'setValue'> & {
  // extend your CategoryColorPickerViewProps
};

export const CategoryColorPickerController = (props: CategoryColorPickerControllerProps): JSX.Element => {
  // Put All your methods and logic here

  const setValue = (value: string) => {
    if (value.toUpperCase() !== props.useFormInstance.getValues(props.name)) {
      props.useFormInstance.setValue(props.name, value.toUpperCase());
    }
  };

  const viewProps: CategoryColorPickerViewProps = { ...props, setValue };
  return <CategoryColorPickerView {...viewProps} />;
};
